"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleValueSelect = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var react_1 = tslib_1.__importDefault(require("react"));
var list_1 = require("../../list");
var dropdown_1 = require("../../dropdown");
var searchbox_1 = require("../../searchbox");
var EmptyTip_1 = require("../../tips/EmptyTip");
var search_filter_1 = require("../../_util/search-filter");
var keys = {
    "8": "backspace",
    "9": "tab",
    "13": "enter",
    "37": "left",
    "38": "up",
    "39": "right",
    "40": "down",
};
var SingleValueSelect = /** @class */ (function (_super) {
    tslib_1.__extends(SingleValueSelect, _super);
    function SingleValueSelect(props) {
        var _this = _super.call(this, props) || this;
        // 父组件调用
        _this.handleKeyDown = function (keyCode) {
            if (!keys[keyCode])
                return;
            var onSelect = _this.props.onSelect;
            var select = _this.state.select;
            switch (keys[keyCode]) {
                case "enter":
                case "tab":
                    if (onSelect) {
                        onSelect(_this.getValue(select));
                    }
                    return false;
                case "up":
                    _this.move(-1);
                    break;
                case "down":
                    _this.move(1);
                    break;
            }
        };
        _this.move = function (step) {
            var select = _this.state.select;
            var values = _this.props.values;
            var list = values;
            if (list.length <= 0)
                return;
            _this.setState({ select: (select + step + list.length) % list.length });
        };
        _this.handleClick = function (e, index) {
            e.stopPropagation();
            if (_this.props.onSelect) {
                _this.props.onSelect(_this.getValue(index));
            }
        };
        var _a = _this.props, values = _a.values, inputValue = _a.inputValue;
        var select = -1;
        values.forEach(function (item, index) {
            if (item.name === inputValue) {
                select = index;
            }
        });
        _this.state = {
            select: select,
            searchValue: "",
        };
        return _this;
    }
    SingleValueSelect.prototype.componentDidMount = function () {
        var select = this.state.select;
        if (select < 0 && this.props.onSelect) {
            this.props.onSelect(this.getValue(select));
        }
    };
    SingleValueSelect.getDerivedStateFromProps = function (props) {
        var values = props.values, inputValue = props.inputValue;
        var list = values.map(function (item) { return item.name; });
        var select = list.indexOf(inputValue);
        return { select: select };
    };
    SingleValueSelect.prototype.getValue = function (select) {
        if (select < 0)
            return [];
        var _a = this.props, values = _a.values, inputValue = _a.inputValue;
        var list = values;
        if (select < list.length) {
            return [list[select]];
        }
        else {
            var select_1 = list.map(function (item) { return item.name; }).indexOf(inputValue);
            this.setState({ select: select_1 });
            if (select_1 < 0)
                return [];
            return [list[select_1]];
        }
    };
    SingleValueSelect.prototype.render = function () {
        var _this = this;
        var _a = this.state, select = _a.select, searchValue = _a.searchValue;
        var _b = this.props, values = _b.values, offset = _b.offset, maxHeight = _b.maxHeight, searchable = _b.searchable;
        var list = values
            .map(function (item, index) { return (tslib_1.__assign(tslib_1.__assign({}, item), { index: index })); })
            .filter(function (_a) {
            var name = _a.name;
            return search_filter_1.searchFilter(name, searchValue);
        })
            .map(function (_a) {
            var index = _a.index, item = tslib_1.__rest(_a, ["index"]);
            return (react_1.default.createElement(list_1.List.Item, { key: index, selected: select === index, onClick: function (e) { return _this.handleClick(e, index); } },
                react_1.default.createElement("span", { title: item.name, style: item.style || {} }, item.name)));
        });
        return (react_1.default.createElement(dropdown_1.DropdownBox, { style: { marginLeft: offset }, onClick: function (e) { return e.stopPropagation(); } },
            !!searchable && (react_1.default.createElement(searchbox_1.SearchBox, { simple: true, value: searchValue, onChange: function (searchValue) { return _this.setState({ searchValue: searchValue }); } })),
            react_1.default.createElement(list_1.List, { type: "option", style: { maxHeight: maxHeight } }, list.length === 0 ? (react_1.default.createElement(list_1.List.StatusTip, null,
                react_1.default.createElement(EmptyTip_1.EmptyTip, null))) : (list))));
    };
    return SingleValueSelect;
}(react_1.default.Component));
exports.SingleValueSelect = SingleValueSelect;
//# sourceMappingURL=SingleValueSelect.js.map